export const spacing = {
    space: {
        sidebar: {
            sm: '3.5rem',
            md: '4.5rem',
        },
    },
};
